<template>
    <div>
        <b-modal id="modal-hash-input" size="xl" title="" header-bg-variant="secondary" centered>
            <b-form>
                <div class="d-block">
                    <b-form-group id="input-group-1" label="01雜湊值" label-for="input-1">
                        <b-form-input id="input-1" v-model="form.input1" type="text" maxlength="64"></b-form-input>
                        <p class="text-alert" v-if="form.input1_error">{{sha256ErrorMsg}}</p>
                    </b-form-group>
                    <b-form-group id="input-group-2" label="02雜湊值" label-for="input-2">
                        <b-form-input id="input-2" v-model="form.input2" type="text" maxlength="64"></b-form-input>
                        <p class="text-alert" v-if="form.input2_error">{{sha256ErrorMsg}}</p>
                    </b-form-group>
                    <b-form-group id="input-group-3" label="03雜湊值" label-for="input-3">
                        <b-form-input id="input-3" v-model="form.input3" type="text" maxlength="64"></b-form-input>
                        <p class="text-alert" v-if="form.input3_error">{{sha256ErrorMsg}}</p>
                    </b-form-group>
                    <b-form-group id="input-group-4" label="04雜湊值" label-for="input-4">
                        <b-form-input id="input-4" v-model="form.input4" type="text" maxlength="64"></b-form-input>
                        <p class="text-alert" v-if="form.input4_error">{{sha256ErrorMsg}}</p>
                    </b-form-group>
                    <b-form-group id="input-group-5" label="05雜湊值" label-for="input-5">
                        <b-form-input id="input-5" v-model="form.input5" type="text" maxlength="64"></b-form-input>
                        <p class="text-alert" v-if="form.input5_error">{{sha256ErrorMsg}}</p>
                    </b-form-group>
                </div>
            </b-form>
            <template #modal-footer>
                <div class="w-100 text-center">
                    <button class="btn-primary-sm mx-3" @click="handleSubmit()">開始驗證</button>
                    <button class="btn-secondary-blue mx-3" id="modal-close" @click="$bvModal.hide('modal-hash-input')">取消</button>
                </div>
            </template>
        </b-modal>
        <b-modal id="modal-hash-result" size="xl" title="" header-bg-variant="secondary" body-bg-variant="lightlightyellow" centered>
            <div v-for="result in validationResults" :key="result.GUID" class="d-block text-left mb-4 p-3 bg-light">
                <p>檔案雜湊值：{{ result.filehash || '' }}</p>
                <b-row>
                    <b-col>
                        <p v-if="result.filehash">驗證結果：<b-icon icon="check-circle-fill" variant="success" aria-hidden="true" class="mr-1"></b-icon><span class="text-success">驗證成功</span></p>
                        <p v-else>驗證結果：<b-icon icon="x-circle-fill" variant="danger" aria-hidden="true" class="mr-1"></b-icon><span class="text-alert">查無資料</span></p>
                    </b-col>
                    <b-col>
                        <p>驗證時間：{{ currentTime }}</p>
                    </b-col>
                </b-row>
                <div class="hash-table mx-3">
                    <b-row class="bg-yellow">
                        <b-col>區塊鏈資訊</b-col>
                    </b-row>
                    <b-row class="bg-lightyellow">
                        <b-col>存證時間</b-col>
                        <b-col>Chaincode名稱</b-col>
                    </b-row>
                    <b-row class="bg-gray">
                        <b-col>{{ result.timestamp || '' }}</b-col>
                        <b-col>MOJ TEST</b-col>
                    </b-row>
                    <b-row class="bg-lightyellow">
                        <b-col>Transation ID</b-col>
                        <b-col>區塊高度</b-col>
                    </b-row>
                    <b-row class="bg-gray">
                        <b-col>{{ result.txId || '' }}</b-col>
                        <b-col>221</b-col>
                    </b-row>
                    <b-row class="bg-lightyellow">
                        <b-col>Chanel名稱</b-col>
                        <b-col>區塊雜湊值</b-col>
                    </b-row>
                    <b-row class="bg-gray">
                        <b-col>MOJ channel</b-col>
                        <b-col>{{ result.filehash || '' }}</b-col>
                    </b-row>
                    <b-row class="bg-yellow">
                        <b-col>存證資訊</b-col>
                    </b-row>
                    <b-row class="bg-lightyellow">
                        <b-col>機關單位</b-col>
                        <b-col>存證人員</b-col>
                    </b-row>
                    <b-row class="bg-gray">
                        <b-col>{{ result.user.user_company || '' }}</b-col>
                        <b-col>{{ result.user.user_name || '' }}</b-col>
                    </b-row>
                </div>
            </div>
            <template #modal-footer>
                <div class="w-100 text-center">
                    <button class="btn-primary-sm mx-3" @click="$bvModal.hide('modal-hash-result')">
                        關閉
                    </button>
                </div>
            </template>
        </b-modal>
        <VerifyResult :items="validateResults" v-if="validateResults.length!=0" />
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import VerifyResult from './VerifyResult.vue'

export default {
    name: "VerifyHash",
    components: {
        VerifyResult
    },
    data() {
        return {
            form: {
                input1: '',
                input2: '',
                input3: '',
                input4: '',
                input5: '',
                input1_error: false,
                input2_error: false,
                input3_error: false,
                input4_error: false,
                input5_error: false,
            },
            validateResults: [],
            validationResults: [],
            currentTime: '',
            sha256ErrorMsg:'格式錯誤，請輸入SHA256雜湊值。',
        }
    },
    methods: {
        isSha256(str) {
            const sha256 = /^[a-z0-9]{64}$/
            return sha256.test(str.toLowerCase());
        },
        async handleSubmit() {
            let inputs = new Array();
            for (let i = 1; i <= 5; i++) {
                let hash = this.form["input" + i];
                if (hash.length) {
                    if (this.isSha256(hash)) {
                        inputs.push(hash)
                    } else {
                        this.form["input" + i + "_error"] = true;
                        return;
                    }
                }
            }
            if(inputs.length == 0){
                this.form["input1_error"] = true;
                return;
            }
            document.getElementById('modal-close').click();
            const requests = inputs.map(item => {
                if (this.isSha256(item))
                    return axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/validate`, {
                        params: {
                            hash: item,
                        }
                    })
            })
            const responses = await Promise.all(requests)
            let verifyTime = moment.unix(Math.floor(Date.now() / 1000)).format('YYYY/MM/DD HH:mm:ss');
            const results = responses.map((response, index) => ({ result: response.data.isValid.status, txMap: response.data.isValid.txMap, user: response.data.isValid.user, verifyTime: verifyTime, fileName: '', hash: inputs[index], index: index + 1 }))
            console.log(results)
            let reportData = {
                verifyTime: verifyTime,
                results: results
            }
            sessionStorage.setItem('reportData', JSON.stringify(reportData));
            this.validateResults = results;
        },
    }
}
</script>
<style>
.bg-lightlightyellow {
    background-color: #FFF8E8;
}
</style>